import { useQuery } from "@apollo/client";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { RxCaretDown } from "react-icons/rx";
import ReactModal from "react-modal";
import {
  GetCitiesAndPrefecturesWithProductsDocument,
  GetCitiesAndPrefecturesWithProductsQuery,
} from "../../../graphql/operations";
import { EventTracker } from "../../Atoms/Analytics";
import CurrencyPicker from "../../Atoms/CurrencyPicker";
import SelectButton from "../../Atoms/SelectButton";
import SearchBar from "../../Cards/SearchBar";
import CheckoutHeader from "../CheckoutHeader";
import Logo from "../Logo";
import { CountryPicker } from "./CountryPicker";
import styles from "./Header.module.scss";
import MobileDestinationPicker from "./MobileDestinationPicker";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [showCurrency, setShowCurrency] = useState(true);
  const router = useRouter();

  const { data, loading } = useQuery<GetCitiesAndPrefecturesWithProductsQuery>(
    GetCitiesAndPrefecturesWithProductsDocument,
    {
      fetchPolicy: "cache-first",
    }
  );
  const locations = useMemo(() => data?.locations.records ?? [], [data]);

  useEffect(() => {
    if (router.pathname === "/bookings/[id]") {
      setShowCurrency(false);
    } else {
      setShowCurrency(true);
    }
  }, [router]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsOpen(false); // Close the modal on route change
    };

    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.events]);

  const isCheckout =
    router.pathname === "/bookings/[id]" ||
    router.pathname === "/checkout/[id]" ||
    router.pathname === "/payments/[id]"
      ? true
      : false;

  const hideHeader =
    isCheckout ||
    router.pathname === "/guide/[guideId]/sign-contracts" ||
    router.pathname === "/guide/sign-contracts-success" ||
    router.pathname === "/bookings/[id]/chat";

  return (
    <>
      {isCheckout ? <CheckoutHeader /> : null}
      {!hideHeader && (
        <div
          id="AppHeader"
          className={styles.AppHeader}
          style={hideHeader ? { display: "none" } : null}
        >
          <div className="AppLayout" style={{ overflow: "inherit" }}>
            <div className={styles.AppHeaderInner}>
              <Link
                href="/?ref=logo"
                title="MagicalTrip Homepage"
                className={styles.AppHeaderLogo}
              >
                <Logo height={40} color="#fff" />
              </Link>

              <CountryPicker locations={locations} loading={loading} />
              <EventTracker
                onClick={{
                  category: "header",
                  action: "click",
                  label: "destination-picker",
                }}
              >
                <SelectButton
                  pressed={isOpen}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <p>Discover</p>
                  <RxCaretDown size={24} style={{ margin: "0px -6px" }} />
                </SelectButton>
              </EventTracker>
              <ReactModal
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                ariaHideApp={false}
              >
                <MobileDestinationPicker
                  router={router}
                  locations={locations}
                  loading={loading}
                />
              </ReactModal>
              <div className={styles.ButtonGroup}>
                <SearchBar variant="tiny" />

                <nav
                  className={styles.AppHeaderNav}
                  style={{ alignItems: "flex-end" }}
                >
                  {showCurrency ? (
                    <ul>
                      <li className={styles.CurrencyDropDown}>
                        <CurrencyPicker />
                      </li>
                    </ul>
                  ) : null}
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <SiteWideMessage /> */}
    </>
  );
}
